import { createContext, useContext } from "react";

// Shared context so the unified Content Hub can push a search string + status filter
// down into ReelsAdmin / ContentEngine / NuggetsAdmin, and each can report a compact
// summary (counts + status dots) back up for its collapsible section header.
// Kept in its own module to avoid a circular import (ContentHub imports the three
// components, and each component imports this context — but never ContentHub itself).
export const ContentHubContext = createContext({
  search: "",
  filter: "all", // all | action | scheduled | posted
  archiveDays: 7,
  reportSummary: () => {},
  embedded: false, // true when rendered inside the hub (hides each component's own heading chrome)
});

export const useHub = () => useContext(ContentHubContext);

// Items older than `archiveDays` are tucked into a collapsed "Archived" drawer — but ONLY
// when they no longer need the admin (drafts / queued / failed always stay visible so the
// panel never hides something that still needs action).
export function olderThan(dateStr, days) {
  if (!dateStr) return false;
  const t = new Date(dateStr).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t > days * 86400000;
}

export function matchesSearch(hay, q) {
  const s = (q || "").trim().toLowerCase();
  if (!s) return true;
  return (hay || "").toLowerCase().includes(s);
}
